import ShieldCheckFilledIcon from './ShieldCheckFilledIcon'

export default ShieldCheckFilledIcon
